// utils/withModulePermission.tsx
import { Outlet, type RouteObject } from 'react-router';

import { PermissionWrapper } from './permissionWrapper';

// This returns a route config with permission check at the root of a module
export const withModulePermission = (module: string, children: RouteObject[]): RouteObject => ({
  path: '', // Allows children to define their own paths
  element: (
    <PermissionWrapper module={module}>
      <Outlet />
    </PermissionWrapper>
  ),
  children, // your module-specific routes like dashboardRoutes, chatRoutes, etc.
});
